import { FETCH_AD_REQUEST } from "../actions/types";

export const adRequestReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_AD_REQUEST:
      return action.payload;
    default:
      return state;
  }
};
